import React, { PureComponent } from 'react';
import { bool, func } from 'prop-types';
import classNames from 'classnames';
import Grid from '@active/react-ui/Grid/Grid';
import GridItem from '@active/react-ui/GridItem/GridItem';
import noop from 'lodash/noop';
import ContactField from './ContactField';

import FIELDS from './config/FIELDS';

export default (configs = []) => {
  const _configs = configs && configs
    .map((config) => {
      if (typeof config === 'string') {
        return FIELDS[config];
      }

      if (config && FIELDS[config.key]) {
        return { ...FIELDS[config.key], ...config };
      }
      return null;
    })
    .filter(field => field);

  if (!_configs || !_configs.length) {
    throw new Error('Construct Contact failed. Config is not validated');
  }

  class Contact extends PureComponent {
    static propTypes = {
      static: bool,
      renderReadyCallback: func,
    };

    static defaultProps = {
      static: false,
      renderReadyCallback: noop,
    }

    render() {
      const { static: isStatic, renderReadyCallback } = this.props;
      const billingClassName = classNames({
        'billing-contact': true,
        'billing-contact-static': isStatic,
      });

      const staticClassName = classNames({
        'cui-mg-t-20': !isStatic,
      });

      return (
        <Grid rowGap={0} container={false} className={billingClassName}>
          {_configs.map(({ field }) => (Array.isArray(field) ? field : [ field ])
            .map((f) => {
              const {
                name, required, label, validator, component: Component, ...rest
              } = f;
              // eslint-disable-next-line no-nested-ternary
              return name === 'address'
                ? <GridItem className={staticClassName}>
                  <Component name={name} {...rest}
                    static={isStatic}
                    required={required}
                    renderReadyCallback={renderReadyCallback} />
                </GridItem>
                : <ContactField name={name} field={f} isStatic={isStatic}/>;
            }),
          )}
        </Grid>
      );
    }
  }

  return Contact;
};
